import CamperImg from "../assets/camper.png";
import CrmImg from "../assets/crm.png";
import Xalqlar from "../assets/xalqlar.webp";
import XalqlarAdmin from "../assets/xalqlar-admin.png";
import CamperAdmin from "../assets/camper-admin.webp";
import KoreaAvto from "../assets/koreavto.png";
import HalalCompass from "../assets/halal.png";

export const projects = [
  {
    id: 1,
    title: "TRIPLi (Admin Dashboard)",
    subtitle: "Web Application",
    image: CamperAdmin,
    link: "https://admin-dashboard.camper.inomjonov.site",
  },
  {
    id: 2,
    title: "TRIPLi",
    subtitle: "Web application",
    image: CamperImg,
    link: "https://tripli.inomjonov.site",
  },
  {
    id: 3,
    title: "EduManSim (Learning Management System)",
    subtitle: "Web application",
    image: CrmImg,
  },
  {
    id: 4,
    title: "Xalplar Do'stligi (Admin-dashboard)",
    subtitle: "Web application",
    image: XalqlarAdmin,
    link: "https://play.google.com/store/apps/details?id=com.xalqlardostligi.app",
  },
  {
    id: 5,
    title: "Xalqlar Do'stligi",
    subtitle: "Web application",
    image: Xalqlar,
    link: "https://xalqlar-dostligi.uz/auth/login",
    description:
      "Empower your delivery operations with our dedicated worker app, designed to simplify task management and enhance your daily workflow. Whether you're delivering groceries, household essentials, or other goods, this app provides all the tools you need to stay organized and deliver with confidence. Our user-friendly platform helps you track and manage orders effortlessly, ensuring every delivery is smooth, accurate, and on time. Built with the needs of delivery professionals in mind, the app offers a reliable solution to handle multiple tasks while minimizing stress and maximizing efficiency",
  },
  {
    id: 6,
    title: "Korea Avto",
    subtitle: "Mobile application",
    image: KoreaAvto,
    link: "https://play.google.com/store/apps/details?id=com.urckoreaauto.app&hl=en",
    description:
      "Designed specifically for the South Korean market, our car marketplace app offers a seamless and intuitive experience for anyone looking to buy or sell vehicles. Whether you're upgrading your ride or listing your current car, our platform connects you with a wide network of buyers and sellers across the country. The app is thoughtfully localized, ensuring that users enjoy a smooth and relevant experience tailored to the unique car market in South Korea. With multilingual support, it breaks language barriers, making car trading more accessible to locals and expats alike.Key Features: Effortless Listings: Post your car for sale in just a few simple steps. Extensive Selection: Explore a wide range of vehicles available nationwide. Localized for South Korea: Built to meet the needs of the South Korean automotive market. Multilingual Experience: Use the app in Korean, English, Simplified Chinese, Vietnamese, or Uzbek. Find your next car or sell your current one — all through a platform that speaks your language and understands your needs. Start your journey today with South Korea’s go-to car marketplace app.",
  },
  {
    id: 7,
    title: "Halal Compass",
    subtitle: "Mobile application",
    image: HalalCompass,
    link: "https://play.google.com/store/apps/details?id=com.urconhalalcompass.app&hl=enn",
    description:
      "At the core of Halal Compass lies a user-focused approach to serving the needs of Muslims around the South Korea. Designed with both practicality and spiritual enrichment in mind, this all-in-one mobile application helps users seamlessly integrate faith into their daily routines. Halal Compass offers precise prayer times tailored to your location, ensuring you never miss a Salah. With built-in tools to locate nearby mosques, halal restaurants, and shops, the app makes it easy to stay connected to your community wherever you are. The platform also features a curated library of Islamic books, articles, and resources, providing users with opportunities to deepen their knowledge and spiritual growth. By combining essential services with user-friendly design, Halal Compass empowers Muslims to navigate modern life while staying firmly rooted in their values. Whether you're at home or traveling, Halal Compass ensures that faith and convenience go hand in hand.",
  },
];
